module.exports = __webpack_public_path__ + "img/banner6.6176e2d9.png";